var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VueTypeaheadBootstrap',{class:[_vm.stateClass],attrs:{"data":_vm.planos,"serializer":(item) => item.nome,"placeholder":_vm.placeholder,"showOnFocus":true,"max-matches":_vm.maxMatches,"size":_vm.size},on:{"hit":_vm.handleSelect},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})
}
var staticRenderFns = []

export { render, staticRenderFns }